import { useEffect } from 'react'

import { useActiveWeb3React } from '../hooks/web3'
import { useAppDispatch } from '../state/hooks'
import { addTransaction, TransactionType } from '../state/transactions/actions'
import { clearReturnedTxHash, peekReturnedTxHash } from './provider'

/**
 * After returning from UZH Wallet (#uzhtx=), register the hash in the app tx list.
 */
export default function ResumeReturnedTx() {
  const { chainId, account } = useActiveWeb3React()
  const dispatch = useAppDispatch()

  useEffect(() => {
    const hash = peekReturnedTxHash()
    if (!hash || !chainId || !account) return
    clearReturnedTxHash()
    dispatch(
      addTransaction({
        hash,
        from: account,
        chainId,
        info: { type: TransactionType.SUBMIT_PROPOSAL },
      })
    )
  }, [account, chainId, dispatch])

  return null
}
